import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "video-page" }
const _hoisted_2 = {
  key: 0,
  class: "page-content__form"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "case-header" }
const _hoisted_5 = { class: "label-s" }
const _hoisted_6 = { class: "case-header__right" }
const _hoisted_7 = {
  key: 0,
  class: "loading-page"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("            ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("\n          ")
const _hoisted_15 = { class: "multisidebar-content__main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectVideoForm = _resolveComponent("SelectVideoForm")!
  const _component_FirstVideoForm = _resolveComponent("FirstVideoForm")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_SettingsMultitool = _resolveComponent("SettingsMultitool")!
  const _component_SidebarTab = _resolveComponent("SidebarTab")!
  const _component_SidebarHeader = _resolveComponent("SidebarHeader")!
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_PageContentLayout = _resolveComponent("PageContentLayout")!
  const _component_VideoProcessPreview = _resolveComponent("VideoProcessPreview")!
  const _component_DeletingVideoConfirm = _resolveComponent("DeletingVideoConfirm")!
  const _component_ProcessingVideoConfirm = _resolveComponent("ProcessingVideoConfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.createEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SelectVideoForm, {
            item: _ctx.item,
            onUpload: _ctx.uploadHandler,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createEnabled = false))
          }, null, 8, ["item", "onUpload"])
        ]))
      : (_ctx.showCreateNewForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_FirstVideoForm, { onCreate: _ctx.createHandler }, null, 8, ["onCreate"])
          ]))
        : (_openBlock(), _createBlock(_component_PageContentLayout, {
            key: 'inner',
            "has-multitool": !!_ctx.selectedItems.length,
            "has-sidebar": _ctx.hasSidebar
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.module.items.length) + " " + _toDisplayString(_ctx.$t(`videos.in_total`)) + ", " + _toDisplayString(_ctx.$t('ds.processed')) + " " + _toDisplayString(_ctx.processedCount) + ", " + _toDisplayString(_ctx.$t('ds.not_processed')) + " " + _toDisplayString(_ctx.notProcessedCount), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.modelAcl.add)
                    ? (_openBlock(), _createBlock(_component_NButton, {
                        key: 0,
                        icon: "upload",
                        onClick: _ctx.createHandler
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('videos.upload', 'f')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_ctx.module.loading && !_ctx.module.loaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_NLoadingCircle)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_NTable, {
                class: "videos-table",
                columns: _ctx.columns,
                content: _ctx.module.items,
                sortValue: _ctx.module.filter.current.ordering,
                "selected-items-ids": _ctx.module.selectedItemIds,
                onSort: _ctx.handleTableSort,
                onCellClick: _ctx.cellClickHandler
              }, null, 8, ["columns", "content", "sortValue", "selected-items-ids", "onSort", "onCellClick"]),
              (_ctx.appModule.settings.debug)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _createTextVNode("\n            Current item: " + _toDisplayString(_ctx.currentItem) + "\n            ", 1),
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true)
            ]),
            multitool: _withCtx(() => [
              (_ctx.selectedItems.length)
                ? (_openBlock(), _createBlock(_component_SettingsMultitool, {
                    key: 0,
                    activable: false,
                    "selected-items": _ctx.selectedItems,
                    "changed-count": _ctx.module.changedSelectedItemsCount,
                    "model-acl": _ctx.modelAcl,
                    "current-item-acl": _ctx.currentItemAcl,
                    "has-current": !!_ctx.currentItem,
                    processable: "",
                    onAction: _ctx.actionHandler
                  }, null, 8, ["selected-items", "changed-count", "model-acl", "current-item-acl", "has-current", "onAction"]))
                : _createCommentVNode("", true)
            ]),
            sidebar: _withCtx(() => [
              (_ctx.currentItem)
                ? (_openBlock(), _createBlock(_component_Sidebar, { key: 0 }, {
                    "sidebar-tabs": _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item) => {
                        return (_openBlock(), _createBlock(_component_SidebarTab, {
                          key: item.id,
                          label: item.name,
                          selected: item.id === _ctx.module.currentItemId,
                          changed: _ctx.module.getHasChangedSelectedItem(item.id),
                          onClick: ($event: any) => (_ctx.module.setCurrentItem(item.id))
                        }, null, 8, ["label", "selected", "changed", "onClick"]))
                      }), 128))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_SidebarHeader, {
                        label: _ctx.module.currentItem.item.name,
                        videoarchive: true,
                        item: _ctx.currentItem,
                        changed: _ctx.module.currentItem.hasChanges,
                        actions: _ctx.sidebarActions,
                        onAction: _ctx.actionHandler
                      }, null, 8, ["label", "item", "changed", "actions", "onAction"]),
                      _createVNode(_component_NTabs, {
                        items: _ctx.tabItems,
                        modelValue: _ctx.activeTab,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
                        class: "multisidebar-content__tabs control-m"
                      }, null, 8, ["items", "modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.isMainTab)
                          ? (_openBlock(), _createBlock(_component_NForm, {
                              key: 0,
                              ref: "form",
                              layout: _ctx.formLayout,
                              model: _ctx.currentItem,
                              state: _ctx.sidebarVideoFormState,
                              disabled: !_ctx.currentItemAcl.update
                            }, null, 8, ["layout", "model", "state", "disabled"]))
                          : (_ctx.isDetectorTab)
                            ? (_openBlock(), _createBlock(_component_NForm, {
                                key: 1,
                                ref: "form",
                                layout: _ctx.formLayout,
                                model: _ctx.currentDetectorItem,
                                state: _ctx.sidebarVideoFormState,
                                disabled: !_ctx.currentItemAcl.update
                              }, null, 8, ["layout", "model", "state", "disabled"]))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["has-multitool", "has-sidebar"])),
    (_ctx.showPlayer)
      ? (_openBlock(), _createBlock(_component_VideoProcessPreview, {
          key: 3,
          item: _ctx.playerItem,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPlayer = false))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.showDeletingVideoConfirm)
      ? (_openBlock(), _createBlock(_component_DeletingVideoConfirm, {
          key: 4,
          targetItems: _ctx.multipleDeleting ? _ctx.selectedItems : [_ctx.currentItem],
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeletingVideoConfirm = false)),
          onDeleteAll: _ctx.deleteAllHandler,
          onDeleteVideoFilesOnly: _ctx.deleteVideoFilesOnly
        }, null, 8, ["targetItems", "onDeleteAll", "onDeleteVideoFilesOnly"]))
      : _createCommentVNode("", true),
    (_ctx.videosForProcess.length)
      ? (_openBlock(), _createBlock(_component_ProcessingVideoConfirm, {
          key: 5,
          targetItems: _ctx.videosForProcess,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.videosForProcess = [])),
          onConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.processVideos(true)))
        }, null, 8, ["targetItems"]))
      : _createCommentVNode("", true)
  ]))
}